import React, { useContext } from "react";
import { AuthContext } from "../../../Contexts/AuthContext";
import { Link } from "react-router-dom";
import "./profile.css";

export default function Profile() {
    const {user}=useContext(AuthContext);

    return (<div className="profile-container">
        <ul className="profile-ul">
            <li className="profile-li">Name : <strong>{user.nom}</strong></li>
            <li className="profile-li">Email : <strong>{user.email}</strong></li>
            <li className="profile-li">role : <strong>{user.role}</strong></li>
            <li className="profile-li">
                <Link to={"/eleveur/user/edit/"+user.id} className="editProfile">Modifier</Link>
            </li>
        </ul>
    </div>)
}